export default __webpack_public_path__ + "static/6-395226fe4ff0a5d1cc597aba945f247b.webp";